module.exports = {
	"de-tal": {
		"routes": {
			"project": "campaign",
			"projects": "campaigns",
			"project_leads": "talents"
		}
	},
	"en-tal": {
		"routes": {
			"project": "campaign",
			"projects": "campaigns",
			"project_leads": "talents"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/talents/routes.yml
// module id = 2039
// module chunks = 0